import React from 'react';

function DownloadIcon(props) {
  return (
    <svg
      viewBox="0 0 18 18"
      {...props}
    >
      <path
        fill="inherit"
        d="M14.652 7.65l-4.945 4.945a1 1 0 01-1.414 0L3.348 7.65a.992.992 0 111.404-1.404L8 9.495V1.698a1 1 0 112 0v7.797l3.248-3.249a.993.993 0 011.404 1.404z"
      />
      <path
        fill="inherit"
        d="M0 12.302a1 1 0 112 0v3h14v-3a1 1 0 112 0v3c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2v-3z"
      />
    </svg>
  );
}

export default DownloadIcon;
